import axios from 'axios'
import {
	Message,
	Loading
} from 'element-ui';
var url = 'http://admin.bruboses.com/burapi'
var shareurl = ''

function post(api, data, showloading = false, showmsg = true) {
	if (api.indexOf('http') == -1) {
		var pathurl = url + api
	} else {
		var pathurl = api
	}
	if (showloading) {
		var loading = Loading.service({
			lock: true,
			text: 'Loading',
			spinner: 'el-icon-loading',
			background: 'rgba(0, 0, 0, 0.7)'
		});
	}
	return new Promise((resolve, reject) => {
		axios({
				url: pathurl,
				method: 'post',
				data: data,
				// headers: {
				// 	Authorization: window.localStorage.token || ''
				// },
			}).then(res => {
				if (showloading) {
					loading.close();
				}
				// 其它状态处理
				if (res.status == 200) {
					if (res.data.code != 200 && showmsg) {
						Message.error(res.data.message)
					}
					resolve(res.data); // 返回数据
				} else if (res.status == 500) {
					resolve({
						code: 0,
						message: '请求失败500'
					}); // 返回数据
				}
			})
			.catch(error => {
				if (showloading) {
					loading.close();
				}
				resolve({
					code: 0,
					message: '请求失败'
				});
			});
	}).catch(error => {});
}

function get(api, data, showloading = false, showmsg = true) {
	if (showloading) {
		var loading = Loading.service({
			lock: true,
			text: 'Loading',
			spinner: 'el-icon-loading',
			background: 'rgba(0, 0, 0, 0.7)'
		});
	}
	return new Promise((resolve, reject) => {
		axios({
				url: url + api,
				method: 'get',
				// headers: {
				// 	Authorization: window.localStorage.token
				// },
				data: data,
			}).then(res => {
				if (showloading) {
					loading.close();
				}
				// 其它状态处理
				if (res.status == 200) {
					if (res.data.code != 200 && showmsg) {
						Message.error(res.data.message)
					}
					resolve(res.data); // 返回数据
				} else if (res.status == 500) {
					resolve({
						code: 0,
						message: '请求失败500'
					}); // 返回数据
				}
			})
			.catch(error => {
				if (showloading) {
					loading.close();
				}
				resolve({
					code: 0,
					message: '请求失败'
				});
			});
	}).catch(error => {});
}
export default {
	url,
	post,
	get,
	shareurl
}
